import { useEffect, useState } from "react";
//Controls
import { Modal, ModalBody, ModalFooter, Button, Chip } from "@gpstrackit/react-controls";
//Components
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import CustomCard from 'Components/Card';
import { Grid } from "@mui/material";

//Actions
import {
    systemAlertContacsOpenModal,
    systemAlertContacsRequest,
    rawMessageViewOpenModal,
    clearRedux
} from 'Redux/actions';

//views
import RawMessageView from 'Modules/devices/.components/rawMessageView'

import { getTransactionsProcessingStatusColor } from 'Core/data/Helpers';

const Contacts = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();

    const { openModal, contact, filters, messagesDetails, loading } = useSelector(state => state.systemAlertContactsRedux);
    const open = useSelector(state => state.rawMessageViewRedux.openModal)

    const [data, setData] = useState(null);

    const closeModal = () => {
        dispatch(systemAlertContacsOpenModal(false));
        setData(null);
        dispatch(clearRedux("SYSTEM_ALT_LOG_CONTACTS"))
    }

    useEffect(() => {
        if (openModal && contact) {
            let newContact = null
            try {
                newContact = JSON.parse(JSON.parse(contact));
            } catch (error) { }
            setData(newContact)
        }
        
        if (openModal && filters) {
            dispatch(systemAlertContacsRequest(filters))
        }
    }, [openModal])

    return (
        <Modal
            open={openModal}
            title={messages['system_alert_logs_tab_contacts']}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 30 }}>
                    {data ? data?.length && data?.map((item, index) => {

                        let messageDetails = messagesDetails?.find(x => x.to === item.address)
                        const currentState = messageDetails ? getTransactionsProcessingStatusColor(messageDetails?.status) : null

                        return (
                            <CustomCard
                                key={index}
                                hideButton
                                width={12}
                            >
                                <Grid container alignContent="center" justifyContent="space-between" className="ctnBtnsTime top10" spacing={1}>
                                    <Grid item sm={messageDetails ? 6 : 12}>
                                        <div style={{ display: 'grid' }}>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['system_alert_logs_tab_name']}</label><span>{item.title}</span>
                                            </div>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['system_alert_logs_tab_email']}</label><span>{item.address}</span>
                                            </div>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['system_alert_logs_tab_type']}</label><span>{item.type}</span>
                                            </div>
                                            {
                                                messageDetails &&
                                                <span>
                                                    <a className="btn-link align-middle" onClick={() => {
                                                        dispatch(rawMessageViewOpenModal(true, "", messages["system_alert_logs_tab_details"], true, messageDetails.message))
                                                    }}>
                                                        {messages['system_alert_logs_tab_view_details']}
                                                    </a>
                                                </span>
                                            }
                                        </div>
                                    </Grid>
                                    {
                                        messageDetails &&
                                        <Grid item sm={6} alignContent="center" >
                                            <div style={{ width: 'fit-content' }} >
                                                <span style={{ width: 'fit-content' }}>
                                                    <Chip
                                                        label={messages[currentState?.label]}
                                                        size="small"
                                                        style={{
                                                            backgroundColor: currentState?.color,
                                                            color: "#ffffff"
                                                        }}
                                                    />
                                                </span>
                                            </div>
                                        </Grid>
                                    }
                                </Grid>
                            </CustomCard>
                        )
                    })
                        : <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', marginTop: 10, opacity: 0.5 }}>{messages['common_no_information_to_display']}</div>
                    }
                </div>
                {open && <RawMessageView />}
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-dark-blue"
                    onClick={() => closeModal()}
                >
                    {messages['close']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}
export default Contacts;